import { combineReducers } from "redux";
import { createStore, applyMiddleware, compose } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import earchiveReducer from "./reducers/earchiveReducer";
import emmReducer from "./reducers/emmReducer";
import invoiceReducer from "./reducers/invoiceReducer";
import despatchReducer from "./reducers/despatchReducer";
import userReducer from "./reducers/userReducer";
import useInvoiceSerialReducer from "./reducers/invoiceSerialReducer";
import useInvoiceDesignReducer from "./reducers/invoiceDesignReducer";
import useBranchDefinitionReducer from "./reducers/branchDefinitionReducer";
import envelopeReducer from "./reducers/envelopeReducer";
import inComingInvoiceReducer from "./reducers/inComingInvoiceReducer";

const rootReducer = combineReducers({
  invoice: invoiceReducer,
  earchive: earchiveReducer,
  emm: emmReducer,
  despatch: despatchReducer,
  user: userReducer,
  invoiceSerial: useInvoiceSerialReducer,
  invoiceDesign: useInvoiceDesignReducer,
  branchDefinition: useBranchDefinitionReducer,
  outEnvelopeList: envelopeReducer,
  inComingInvoice: inComingInvoiceReducer,
});

const enhancer =
  process.env.NODE_ENV === "development"
    ? composeWithDevTools(applyMiddleware(thunk))
    : compose(applyMiddleware(thunk));

const store = createStore(rootReducer, enhancer);

export default store;
